module.exports = __webpack_public_path__ + "static/media/smart.e11764d5.svg";